const formFields = {
  'advisers-leads': {
    advisoryObjective: {
      name: '¿Con qué necesitas ayuda?',
      type: 'enum',
      values: {
        invest: 'Invertir tus ahorros',
        retirement: 'Preparar tu jubilación',
        mortgage: 'Elegir una hipoteca',
        taxes: 'Fiscalidad & Renta'
      },
      order: 1,
      hidden: false
    },
    financialWealthRange: {
      name: '¿Cómo es tu patrimonio sin contar inmuebles?',
      type: 'enum',
      values: {
        'r-0-10000': 'Menos de 10.000€',
        'r-0-50000': 'Menos de 50.000€',
        'r-10000-50000': 'Entre 10.000€ y 50.000€',
        'r-50000-300000': 'Entre 50.000€ y 300.000€',
        'r-300000-600000': 'Entre 300.000€ y 600.000€',
        'r-600000-max': 'Más de 600.000€'
      },
      order: 2,
      hidden: false
    },
    monthlySavingRange: {
      name: '¿Cuánto puedes ahorrar al mes?',
      type: 'enum',
      values: {
        'r-0-0': 'Ninguno',
        'r-0-200': 'Entre 0€ y 200€',
        'r-200-1000': 'Entre 200 y 1000€',
        'r-1000-3000': 'Entre 1.000€ y 3.000€',
        'r-3000-max': 'Más de 3.000€',
        'r-200-500': 'Entre 200€ y 500€',
        'r-3000-6000': 'Entre 3.000€ y 6.000€',
        'r-500-1000': 'Entre 500€ y 1.000€',
        'r-6000-max': 'Más de 6.000€'
      },
      order: 3,
      hidden: false
    },
    age: {
      name: '¿Qué edad tienes?',
      type: 'string',
      values: {},
      order: 4,
      hidden: false
    },
    isLegalTermsAccepted: {
      name: 'Acepta términos y condiciones',
      type: 'enum',
      values: {
        true: 'Si',
        false: 'No'
      },
      order: 5,
      hidden: true
    },
    zipcode: {
      name: '¿Cuál es tu código postal?',
      type: 'string',
      values: {},
      order: 6,
      hidden: false
    },
    contactTimes: {
      name: '¿A qué hora prefieres que te contacten?',
      type: 'array',
      values: {
        morning: 'Por la mañana',
        afternoon: 'A Mediodía',
        evening: 'Por la tarde'
      },
      order: 7,
      hidden: false
    },
    contactMethods: {
      name: '¿Cómo te gustaría que fuese el primer contacto?',
      type: 'array',
      values: {
        phone: 'Por teléfono',
        email: 'Por Mail',
        whatsapp: 'Por Whatsapp'
      },
      order: 8,
      hidden: false
    },
    isCommunicationInPerson: {
      name: '¿Consideras necesario tener reuniones presenciales con tu asesor?',
      type: 'enum',
      values: {
        true: 'Si',
        false: 'No'
      },
      order: 9,
      hidden: false
    },
    currentAdvisor: {
      name: '¿Eres cliente de alguna empresa de asesoramiento actualmente?',
      type: 'string',
      values: {},
      order: 10,
      hidden: false
    },
    declaredRiskProfile: {
      name: '¿Cuál es tu perfil inversor?',
      type: 'enum',
      values: {
        aggressive: 'Agresivo',
        conservative: 'Conservador',
        moderate: 'Moderado'
      },
      order: 11,
      hidden: false
    },
    timeHorizonRange: {
      name: '¿Qué horizonte temporal tienes para recuperar tu inversión?',
      type: 'enum',
      values: {
        'r-1-5': 'Entre 1 y 5 años',
        'r-5-10': 'Entre 5 y 10 años',
        'r-10-max': 'Más de 10 años'
      },
      order: 12,
      hidden: false
    },
    phoneNumber: {
      name: '¿En qué teléfono podemos contactar contigo?',
      type: 'string',
      values: {},
      order: 13,
      hidden: false
    },
    fullName: {
      name: '¿Cómo te llamas?',
      type: 'string',
      values: {},
      order: 14,
      hidden: false
    },
    email: {
      name: '¿Cuál es tu dirección de correo electrónico?',
      type: 'string',
      values: {},
      order: 15,
      hidden: false
    },
    acceptsDataCession: {
      name: 'Acepta cesión de datos',
      type: 'enum',
      values: {
        true: 'Si',
        false: 'No'
      },
      order: 18,
      hidden: true
    }
  },

  taxdown: {
    age: {
      name: 'Edad actual',
      type: 'string',
      values: {},
      order: 1,
      hidden: false
    },
    annualGrossIncome: {
      name: 'Salario anual bruto',
      type: 'string',
      values: {},
      order: 2,
      hidden: false
    },
    childrenAge: {
      name: 'Edades de los hijos',
      type: 'array',
      values: {},
      order: 4,
      hidden: false
    },
    childrenNumber: {
      name: 'Número de hijos',
      type: 'string',
      values: {},
      order: 3,
      hidden: false
    },
    dni: {
      name: 'Documento Nacional de Identidad',
      type: 'string',
      values: {},
      order: 5,
      hidden: false
    },
    email: {
      name: 'Correo electrónico',
      type: 'string',
      values: {},
      order: 6,
      hidden: false
    },
    financialProductsOwned: {
      name: 'Productos financieros poseídos',
      type: 'array',
      values: {
        deposits: 'Depósitos bancarios',
        estate: 'Inmuebles',
        etfs: 'ETFs',
        funds: 'Fondos de inversión',
        none: 'Ninguno',
        plans: 'Planes de pensiones',
        roboadvisors: 'Roboadvisors',
        'saving-insurances': 'Seguros de ahorro',
        shares: 'Acciones',
        sicavs: 'SICAVs'
      },
      order: 7,
      hidden: false
    },
    fullName: {
      name: 'Nombre completo',
      type: 'string',
      values: {},
      order: 8,
      hidden: false
    },
    houseOwnershipType: {
      name: 'Régimen de tenencia de vivienda',
      type: 'enum',
      values: {
        'additional-estate': 'Cuentas con otros inmuebles en propiedad',
        none: 'Ninguna de las anteriores',
        other: 'Otro',
        owned: 'Propia',
        rented: 'Alquilada'
      },
      order: 9,
      hidden: true
    },
    isLegalTermsAccepted: {
      name: 'Acepta términos y condiciones',
      type: 'enum',
      values: {
        true: 'Si',
        false: 'No'
      },
      order: 10,
      hidden: true
    },
    isPaisVascoOrNavarra: {
      name: 'País Vasco o Navarra',
      type: 'enum',
      values: {
        true: 'Si',
        false: 'No'
      },
      order: 11,
      hidden: false
    },
    jobStatus: {
      name: 'Situación laboral',
      type: 'enum',
      values: {
        'civil-servant': 'Funcionario',
        permanent: 'Indefinido',
        retired: 'Jubilado',
        'self-employed': 'Autónomo',
        temporary: 'Temporal',
        unemployed: 'Desempleado'
      },
      order: 12,
      hidden: false
    },
    maritalStatus: {
      name: 'Estado civil',
      type: 'enum',
      values: {
        divorced: 'Divorciado',
        married: 'Casado',
        single: 'Soltero',
        widowed: 'Viudo'
      },
      order: 13,
      hidden: false
    },
    mortgageOutstanding: {
      name: 'Capital pendiente de la hipoteca',
      type: 'string',
      values: {},
      order: 14,
      hidden: false
    },
    phoneNumber: {
      name: 'Teléfono de contacto',
      type: 'string',
      values: {},
      order: 15,
      hidden: false
    },
    taxReturnHousingsStatus: {
      name: 'Estatus de inmuebles',
      type: 'array',
      values: {
        'additional-estate': 'Cuentas con otros inmuebles en propiedad',
        none: 'Ninguna de las anteriores',
        'other-estate-sale': 'Has vendido otros inmuebles',
        owned: 'Eres propietario de tu vivienda habitual',
        'primary-residence-sale': 'Has vendido tu vivienda habitual',
        'rent-income': 'Recibes ingresos por alquiler de inmuebles',
        rented: 'Vives de alquiler'
      },
      order: 16,
      hidden: false
    },
    zipcode: {
      name: 'Código postal',
      type: 'string',
      values: {},
      order: 17,
      hidden: false
    }
  }
};

export const getFormData = (appId, data) =>
  Object.entries(data)
    .map(item => ({
      fieldName: item[0],
      type: formFields[appId][item[0]].type,
      userValue: {
        value: item[1],
        date: ''
      },
      definition: {
        name: formFields[appId][item[0]].name,
        values: formFields[appId][item[0]].values,
        order: formFields[appId][item[0]].order,
        hidden: formFields[appId][item[0]].hidden
      }
    }))
    .sort((itemA, itemB) => (itemA.definition.order < itemB.definition.order ? -1 : 1))
    .filter(item => !item.definition.hidden);
